import type { ApiRoute } from "../api"
import type { CalculateExtraCostsPriceBreakdownView } from "./CalculateExtraCostsPriceBreakdownView"

export interface CalculateExtraCostsPriceBreakdownHandlerPathParams {
	inventoryId: string
}

export interface CalculateExtraCostsPriceBreakdownHandlerQueryParams {
	useInventoryPriceService?: boolean
}

export interface CalculateExtraCostsPriceBreakdownHandlerBody {
	selectedExtraCostIds: string[]
	vatDeductible: boolean
	vehiclePrice?: number
}

export const calculateExtraCostsPriceBreakdownRoute: ApiRoute<
	CalculateExtraCostsPriceBreakdownHandlerPathParams,
	CalculateExtraCostsPriceBreakdownHandlerQueryParams,
	CalculateExtraCostsPriceBreakdownHandlerBody,
	CalculateExtraCostsPriceBreakdownView
> = {
	buildUrl: (pathParams, queryParams) => {
		const urlSearch = queryParams?.useInventoryPriceService
			? `?useInventoryPriceService=${queryParams.useInventoryPriceService}`
			: ""
		return `/vehicles/${pathParams.inventoryId}/calculate-price${urlSearch}`
	},
	method: "post",
	path: "/vehicles/:inventoryId/calculate-price",
}
